import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Hobby2SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M7.53.53 7 0 5.94 1.06l.53.53.22.22H3.374a3.375 3.375 0 0 0 0 6.75h9.25a1.875 1.875 0 0 1 0 3.75h-7.74a2.501 2.501 0 1 0 0 1.5h7.74a3.375 3.375 0 1 0 0-6.75h-9.25a1.875 1.875 0 0 1 0-3.75h3.314l-.22.22-.53.53L7 5.122l.53-.53 1.324-1.323a1 1 0 0 0 0-1.415L7.53.53ZM2.5 14.06a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12-11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Hobby2SVG;
